export const SET_SAP_INFO = 'SET_SAP_INFO';
export const RESET_SAP_INFO = "RESET_SAP_INFO";

const initialState = {
  firstName: '',
  lastName: '',
  birthDate: '',
  birthCity: '',
  siret: '',
  address: '',
  signCity: '',

}

export default  function procurationSapReducers(state = initialState, action:any) {
    switch (action.type) {
      case SET_SAP_INFO:
        return action.payload;
      case RESET_SAP_INFO:
        return null;
      default:
        return state;
    }
  }